module.exports = __webpack_public_path__ + "img/web-development-company.406d8077.jpg";